<template>
  <div class="work">
    <div class="container work__container">
      <h2 class="work__title content-title" v-html="work.title"></h2>
      <div class="work__row row">
        <div
          v-for="(item, index) in work.cta"
          :key="index"
          class="work__item work-item col-6 col-sm-12"
        >
          <div class="work-item__text" v-html="item.text"></div>
          <div class="work-item__btn">
            <router-link
              class="btn btn--primary"
              :to="`/${index > 0 ? 'signup' : 'registration'}`"
            >
              {{ item.button }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    work: Object,
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/style/views/home/work.scss";
</style>
